import { render, staticRenderFns } from "./ProductoPedidoDialog.vue?vue&type=template&id=7687a6ae"
import script from "./ProductoPedidoDialog.vue?vue&type=script&lang=js"
export * from "./ProductoPedidoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports